import React from 'react'

import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  size?: 'default' | 's'
  space?: 'default' | 's'
  checked?: boolean
  minor?: boolean
}

const List = ({
  classNames,
  children,
  size = 'default',
  space = 'default',
  minor = false,
  checked = false,
}: Props) => (
  <ul
    className={cn(
      'List',
      {[`size-${size}`]: !!size, [`space-${space}`]: !!space, minor, checked},
      classNames
    )}
  >
    {mapChildrenWithFragments(children, child => React.cloneElement(child, {checked}))}
  </ul>
)

export default List
